<template>
    <dropdown :dropdown-trigger="$i18n.locale.toUpperCase()" icon="mdi-web">
        <li v-for="language in supportedLanguages" :key="language">
            <a @click="selectLanguage(language)" href="#">
                <span class="dropdown__item__img">
                    <img :src="localeFlag(language)" />
                </span>
                {{ language.toUpperCase() }}
            </a>
        </li>
    </dropdown>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { supportedLanguages, changeLanguage } from '@/languages';
import Dropdown from '@/components/Dropdown';
import flagEN from '@/assets/images/flag-en.svg';
import flagDE from '@/assets/images/flag-de.svg';
import flagCN from '@/assets/images/flag-cn.svg';

@Component({
    components: {
        Dropdown,
    },
})
export default class LanguageSwitcher extends Vue {
    supportedLanguages = supportedLanguages;
    selectLanguage(locale) {
        changeLanguage(locale);
        this.$eventHub.$emit('language-changed');
    }

    localeFlag(locale) {
        switch (locale) {
            case 'en':
                return flagEN;
            case 'de':
                return flagDE;
            case 'cn':
                return flagCN;
        }
    }
}
</script>
